import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService, Dialog } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { User, UserType, UserTypeNotSystemEnum, UserTypeForClientUserAdmin } from '../../users/users.models';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { CompaniesService } from '../../companies/companies.service';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { TranslateService } from '@ngx-translate/core';
import { Role } from '../../roles/roles.models';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-users-form',
  templateUrl: './users-form.component.html',
  styleUrls: ['./users-form.component.scss']
})
export class UsersFormComponent extends BaseFormComponent implements OnInit {
  public companies: OptionsSource;
  public roles: DataSource;
  public groups: string[] = [];
  public allRoles: any[] = [];
  public allRolesGrouped: any[] = [];
  public userTypes: ValueLabel[] = [];
  public unclassified: string;

  public isCurrentUserSystem: boolean = false;
  public myUser: boolean = false;
  public canReadRoles: boolean = true;
  public activeText: string;
  public UserType = UserType;

  constructor(
    private companiesService: CompaniesService,
    private translateService: TranslateService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    protected usersService: UsersService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void {
    this.authorities.init('C_USR', 'R_USR', 'U_USR', null);

    this.url = `${Constants.contextPath}/users`;
    this.prepareLookupData();
    this.prepareFormData(new User(), (response: User) => {
      return this.modifyResponse(response);
    });
  }

  public modifyResponse(response: User) {
    response.breadcrumbsId = response.name;
    this.myUser = response.id == this.authService.userId;
    this.active = response.active;        
    
    if (response.roles) {
      if (this.allRolesGrouped.length == 0) {
          this.roles = this.prepareDataSource(this.prepareGroups(response.roles));
      }

      let roles = [];
      for (let r of response.roles as Role[])
          roles.push(r.value);

      response.roles = roles;
  }

    this.activeText = response.active ? 'SHARED.DEACTIVATE' : 'SHARED.ACTIVATE';
    if (response.userType != UserType[UserType.SYSTEM])
      this.companies = this.companiesService.getCompaniesOptions();
    return response;
  }

  private prepareLookupData() {
    this.isCurrentUserSystem = this.authService.userType == UserType[UserType.SYSTEM];
    this.canReadRoles = this.authService.hasAuthority('R_RL');
    this.unclassified = this.translateService.instant('ROLES.UNCLASSIFIED');

    this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(this.setUserEnum(), true), 'value', 'label', 'ENUMS.USER_TYPES.');
    
    this.roles = this.prepDataSource();
    if (this.id == null)
      this.companies = this.companiesService.getCompaniesOptions();
  }

  private setUserEnum() {
    if(this.authService.userType == UserType[UserType.CLIENT_USER_ADMIN] && this.id == null)
      return UserTypeForClientUserAdmin;
    else if(!this.isCurrentUserSystem)
      return UserTypeNotSystemEnum;
    else
      return UserType;
  }

  private prepareGroups(list: any[]) {
    for (let item of list)
      if (item.groups == null)
        item.groups = this.unclassified;
    let groups = [...new Set(list.map(item => item.groups))];
    let resultList = [];
    for (let group of groups) {
      resultList.push({
        type: group,
        collection: list.filter(item => item.groups == group)
      });
    }
    return resultList;
  }

  private prepDataSource() {
    return new DataSource({
      key: 'id',
      group: 'groups',
      store: new CustomStore({
        load: () => {
          return this.baseService.getAllAsPromise(`${Constants.contextPath}/roles/list`, 0, '', '', (result) => {
            let response = result.content ? result.content : result;
            this.allRoles = response;
            
            this.allRolesGrouped = this.prepareGroups(response);
            
            this.sortByParent(this.allRolesGrouped);
            
            this.roles = this.prepareDataSource(this.allRolesGrouped);
            
            for (let item of this.allRolesGrouped)
              if (item.type != null)
                this.groups.push(item.type);
          });
        },
        loadMode: 'raw'
      })
    });
  }

  private sortByParent(allRolesGrouped: any[]){
    allRolesGrouped.forEach(group => {
      let col = group.collection;
      if(col.length<=1)
        return;
      
      for(let i=0;i<col.length;i++){        
        let temp = col[i];

        if(temp.parent != null){
          let indexParent = col.findIndex(x => x.id == temp.parent);         
          
          if(indexParent > i) {
            group.collection = this.utilityService.arrayMove(col, i, indexParent);
          }

        }
      }
    });
  }

  private prepareDataSource(list: { type: string, collection: any }[]) {
    return new DataSource({
      store: list,
      map: function (item) {
        return {
          key: item.type,
          items: item.collection
        }
      }
    });
  }

  // private extractValues(list) {
  //   if (Array.isArray(list)) {
  //     for (let item of list)
  //       item.description = `${item.value}: ${item.description}`;
  //     return list;
  //   } else {
  //     list.description = `${list.value}: ${list.description}`;
  //     return list;
  //   }
  // }

  public resetFailedLoginAttempts(){
    this.usersService.resetFailedLoginAttempts(this.id, 
      () => {
        this.alertService.success('USERS.RESET_FAILED_LOGIN_ATTEMPTS_SUCCESS');
    })
  }
  
  public modifyRoles(roles) {
    let modifiedRoles = [];

    for (let role of roles) {
      let foundRole = this.allRoles.find(r => r.value == role);
      if (foundRole)
        modifiedRoles.push(foundRole.id);
    }
    return modifiedRoles;
  }

  public saveChanges(): void {
    this.formData.companyId = this.isCurrentUserSystem ? this.formData.companyId : this.authService.companyId;

    this.formData.email = (<User>this.formData).email.trim();
    this.formData.login = (<User>this.formData).login.trim();
    
    if (!this.isFormValid())
      return;

    let data = JSON.parse(JSON.stringify(this.formData))

    if (data.roles)
      data.roles = this.modifyRoles(data.roles);

    if (this.id == null) {
      this.baseService.create(this.url, data, () => {
        this.onSaveSuccess();
      });
    }
    else {
      this.baseService.update(this.url, data, () => {
        this.onSaveSuccess();
      });
    }
  }
}
